import {useQuery} from 'react-query';
import {request} from '../Client';
import {ApiOperation} from '../utilis/Api';
import {ISearchDocumentsResponseType} from '../utilis/ResponseObjects.types';
import useSetLoadingState from '../../utilis/useSetLoadingState';
import searchDocumentResponseTransformer from './utilis/searchDocumentResponseTransformer';

const useSearchQuery = (text: string) => {
  const query = useQuery(['searchDocument', text], async () => {
    const res = await request<ISearchDocumentsResponseType>({
      operation: ApiOperation.SearchDocuments,
      urlParams: {text}
    });
    return searchDocumentResponseTransformer(res.data);
  }, {
    enabled: text !== ''
  });

  useSetLoadingState(query.isFetching);

  return query;
}

export default useSearchQuery;